export default __webpack_public_path__ + "static/media/faci17.7694e24e.jpg";